import { InMemoryCache } from "@apollo/client";

const apolloClientCache = new InMemoryCache();
export const getApolloClientCache = () => apolloClientCache;
